
import auth from './auth'
import calculatorView from './calculator_view'
import conceptualFrameworks from './conceptual_frameworks'
import dashboard from './dashboard'
import demographicReport from './demographic_report'
import enterprises from './enterprises'
import errors from './errors'
import evaluations from './evaluations'
import help from './help'
import individualReport from './individual_report'
import input from './input'
import instructive from './instructive'
import languages from './languages'
import navigation from './navigation'
import operationSummary from './operation-summary'
import organizationalReport from './organizational_report'
import outside from './outside'
import pluralization from './pluralization'
import pricing from './pricing'
import questionnaires from './questionnaires'
import questions from './questions'
import reports from './reports'

export default {
  /* Gerenal labels */
  title: 'OCC Solutions - Pulse',
  active: 'Active',
  inactive: 'Inactive',
  no_data: 'No records',
  registration_updated_successfully: 'Registration updated successfully',
  record_saved_successfully: 'Record saved successfully',
  error_trying_update: 'There was an error trying to update',
  error_trying_save: 'An error occurred while trying to save',
  copyright: 'All rights reserved 2019',
  go_back: 'Go Back',
  results_per_pages: 'Results per pages',
  manual: 'Help manuals',
  go_to_manual: 'Click here to go to the manuals section',
  page_all: 'All',
  /* Models */
  models: {
    enterprises: 'Enterprises',
    groups: 'Groups',
    pulse: 'Pulse'
  },
  waiting: 'Please wait',
  maintenance: 'Page under construction',
  // tslint:disable-next-line:max-line-length
  maintenance_text: 'We work each day to achieve the objectives<br/>and give you the best results and experiences.',
  /* Labels grouped by modules or type */
  auth,
  calculatorView,
  conceptualFrameworks,
  dashboard,
  demographicReport,
  enterprises,
  errors,
  evaluations,
  help,
  individualReport,
  input,
  instructive,
  languages,
  navigation,
  operationSummary,
  organizationalReport,
  outside,
  pluralization,
  pricing,
  questionnaires,
  questions,
  reports,
  page_text: 'of'
}
